export default "__VITE_ASSET__V8UnXCW2__"